import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Resolve tenant by domain — public, no auth required
// Called on app load to get companyId before login
const getByDomain = async (domain) => {
    const response = await axios.get(`${API_URL}/api/companies/by-domain`, { params: { domain } });
    return response.data; // { companyId, name, logoUrl }
};

// Get all companies
const getCompanies = async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/companies`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Create a new company
const createCompany = async (name) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(
        `${API_URL}/api/companies`,
        { name },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};

const updateSettings = async (settings) => {
    const token = localStorage.getItem('token');
    const response = await axios.patch(`${API_URL}/api/companies/settings`, settings, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

const getLogoUploadUrl = async (fileName, contentType) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(
        `${API_URL}/api/companies/logo-upload-url`,
        { fileName, contentType },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data; // { uploadUrl, publicUrl }
};

const companyService = {
    getByDomain,
    getCompanies,
    createCompany,
    updateSettings,
    getLogoUploadUrl,
};

export default companyService;
